// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3hkf3","rootSuccess":"CompleteLink_rootSuccess__39u20","rootFailure":"CompleteLink_rootFailure__UbN8S","isDisabled":"CompleteLink_isDisabled__3ENuM"};